<div class="input-group sg-input-group"
     [class.sg-input-group__secondary]="inputStyle == 'secondary'"
     [class.sg-input-group__icon]="icon"
     [class.sg-input-group__error]="errors.length > 0"
     [class.sg-input-group__focus]="focused">
    <div class="input-group-prepend sg-input-group__prepend sg-rounded-left" *ngIf="icon">
        <div class="sg-input-group__prepend__icon h-100 sg-rounded-left d-flex align-items-center justify-content-center">
            <mlp-ng-icon class="mw-100" name="{{icon}}"></mlp-ng-icon>
        </div>
        <div class="sg-input-group__prepend__divider d-flex align-items-center">
            <div class="sg-input-group__prepend__divider__line"></div>
        </div>
    </div>
    <input [type]="inputType" [id]="inputId" class="form-control sg-input-group__input-molecule"
        [placeholder]="placeholder" (input)="updateValue($event)" [value]="value" [name]="inputName"
        [disabled]="inputDisabled" (focus)="focused = true; focus.emit($event)" (blur)="focused = false; blur.emit($event)">
    <div class="input-group-append sg-input-group-append sg-rounded-right" *ngIf="iconSecondary">
        <div class="sg-rounded-right">
            <button *ngIf="loading" type="button" class="btn sg-btn h-100 sg-input-group-append-button-icon sg-input-group-append-button-icon__loading">
                <mlp-ng-spinner class="mr-2"></mlp-ng-spinner>
            </button>
            <button *ngIf="!loading" type="button" class="btn sg-btn h-100 sg-input-group-append-button-icon" (click)="secondaryButtonClick.emit()">
                <mlp-ng-icon class="mw-100" name="{{iconSecondary}}"></mlp-ng-icon>
            </button>
        </div>
    </div>
</div>
<small class="form-text sg-color__danger" *ngFor="let error of errors">{{ error.title }}</small>
